import React, { PureComponent, useContext, useState } from 'react'
import { TaskContext } from '../../context/task';

export default function useSearch() {
    const [keyword, setKeyword] = useState('');
    const [tasks, setTasks] = useContext(TaskContext);
    
    let filteredTask= tasks?.filter((e)=> e.task.toLowerCase().includes(keyword))

    


    return {keyword,setKeyword,filteredTask}
  
}
